<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r10"> 이미지 - 폴더 이름[ {{data.customimagetypeName}} ]</div>
      <el-upload :before-upload="(file) => file" action="" :auto-upload="false" :show-file-list="false" accept :on-change="onUploadImage" ref="reportUpload" multiple>
        <!-- add padding 1207 ie friendly -->
        <el-button class="mr-r4" style="padding-top: 2.5px" type="secondary" size="medium">올리기</el-button>
      </el-upload>
      <el-button class="mr-r4" type="primary" size="small" :disabled="!checkedFlag" @click="onDownloadImg">내려받기</el-button>
      <el-button size="small" :disabled="!checkedFlag" @click="onDeleteImg">삭제</el-button>
    </div>
    <w-search-field ref="searchField" width="250px" @search="onImgSearch" />
  </el-row>
  <hr class="mr-b20" style="margin-top:0px;" />
  <el-row :gutter="10" v-if="!showEmptyText">
    <el-col :span="4">
      <div class="folder-wrapper" @dblclick="onBackToGroupList">
        <div class="folder-border">
          <div class="image-inner c-dblclick">
            <div class="icon-up"></div>
            <div class="up">상위단계</div>
          </div>
        </div>
      </div>
    </el-col>
    <w-img-box v-for="item in imgGroups" ref="imgBox" :key="item.customimageId" :data="item" @change-img-name="changeImgName" @check-change="onCheckChange" />
  </el-row>
  <!-- SettingContentTemplate는 공통 컴포넌트여서 아래와 같이 style 수정 -->
  <div v-else-if="showEmptyText" style="margin-top: 240px; display: flex; justify-content: center; align-items: center; font-size: 16px;">
    {{this.emptyText}}
  </div>
</div>
</template>
<!-- 0306 추가 -->
<style lang="scss" scoped>
.el-col {width: 197px}
@media only screen and (max-width: 1455px) {
  .el-col {width: 197px}
}
</style>

<script>
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import { forEach, cloneDeep, isEmpty, findIndex } from 'lodash';
import msgUtil from '@/utils/message';
import WSearchField from '@/components/form/SearchField';
import WImgBox from './components/ImgBox';

export default {
  name: 'WImageList',
  components: {
    WImgBox,
    WSearchField,
  },
  props: {
    data: {
      type: Object,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgGroups: [],
      imgOriginGroups: [],
      checkedFlag: false,
      emptyText: '데이터 없음',
      showEmptyText: false,
    };
  },
  watch: {
    active(to) {
      if (!to) {
        this.reset();
      }
    },
  },
  methods: {
    loadData() {
      const params = {
        customimagetypeId: this.data.customimagetypeId,
      };
      this.checkedFlag = false;
      OperationSettingsAPI.getImageList(params)
        .then((response) => {
          if (response.data.success) {
            this.imgGroups = response.data.data;
            this.imgOriginGroups = cloneDeep(this.imgGroups);
          } else {
            this.imgGroups = [];
            this.imgOriginGroups = [];
          }
        })
        .catch(() => {
          this.imgGroups = [];
          this.imgOriginGroups = [];
        });
    },
    onBackToGroupList() {
      this.$emit('dblclick-img');
    },
    changeImgName(params) {
      const target = '이미지명';
      const action = msgUtil.action.MODIFY;

      OperationSettingsAPI.setCustomImage(params)
        .then((response) => {
          if (response.data.success) {
            const index = findIndex(this.imgOriginGroups, (item) => item.customimageId === params.customimageId);
            this.imgOriginGroups[index].customimagetypeName = params.customimagetypeName;
            this.$message(msgUtil.getResultMsgData(action, target, true));
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
            this.imgGroups = cloneDeep(this.imgOriginGroups);
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    // 이미지를 업로드한다.
    onUploadImage(item) {
      // 파일 등록 api
      const data = new FormData();
      data.append('customimagetypeId', this.data.customimagetypeId);
      data.append('customimageName', item.name);
      if (item.uid) {
        data.append('image', item.raw);
      }

      const target = '이미지';
      const action = '업로드';
      OperationSettingsAPI.addCustomImage(data)
        .then((response) => {
          if (response.data.success) {
            this.loadData();
            this.$message(msgUtil.getCustomResultMsgData(response.data.message, true));
          } else {
            this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    // 이미지를 삭제합니다.
    onDeleteImg() {
      const params = [];
      forEach(this.$refs.imgBox, (item) => {
        if (item.checked) {
          params.push(item.data.customimageId);
        }
      });
      if (params.length > 0) {
        const action = msgUtil.action.DELETE;
        const target = '이미지';
        this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE))
          .then(() => {
            if (params.length > 0) {
              OperationSettingsAPI.deleteCustomImage(params)
                .then((response) => {
                  if (response.data.success) {
                    this.$message(msgUtil.getResultMsgData(action, target, true));
                    this.loadData();
                  } else {
                    this.$message(msgUtil.getResultMsgData(action, target, false));
                  }
                })
                .catch(() => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                });
            }
          })
          .catch(() => {});
      } else {
        this.$message(msgUtil.getRequireMsgData(msgUtil.action.SELECT, '삭제할 이미지'));
      }
    },
    // 이미지 내려받기
    onDownloadImg() {
      const list = [];
      forEach(this.$refs.imgBox, (item) => {
        if (item.checked) {
          list.push({
            customimageName: item.data.customimageName,
            customimageMimetype: item.data.customimageMimetype,
            customimagetypeId: item.data.customimagetypeId,
            customimageId: item.data.customimageId,
          });
        }
      });
      const params = {
        list: JSON.stringify(list),
      };
      OperationSettingsAPI.downloadCustomImage(params);
    },
    // 이미지 검색
    onImgSearch(searchValue) {
      const keyword = searchValue ? searchValue.toLowerCase() : false;
      const target = this.imgOriginGroups.filter((value) => {
        if (!keyword) return true;
        return value.customimageName.toLowerCase().indexOf(keyword) > -1;
      });
      this.imgGroups = target;
      // 검색결과 없을 경우 도움말
      if (!this.imgGroups.length) {
        this.showEmptyText = true;
      } else if (this.imgGroups.length) {
        this.showEmptyText = false;
      }
      if (!this.imgGroups.length && keyword === false) { // 빈 폴더에서 검색키워드 없을 경우
        this.showEmptyText = false;
      }
    },
    onCheckChange(data, value) {
      let checked = false;
      forEach(this.imgGroups, (item) => {
        if (data.customimageId === item.customimageId) {
          item.checked = value;
        }
        if (checked === true) return;
        if (item.checked === true) {
          checked = true;
        }
      });

      this.checkedFlag = checked;
    },
    reset() {
      if (!isEmpty(this.imgGroups)) { // 동일한 폴더를 조회하는 경우 선택이 유지되지 않도록 체크가 해제되도록 처리
        this.imgGroups = cloneDeep(this.imgOriginGroups);
      }
      this.$refs.searchField.clear();
      this.checkedFlag = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/ImageSettings/ImageSettingsView/ImageList.vue